<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 19:51:03
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceRecordModiApp\AttendanceRecordModiApp.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 15:34:20
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_admin_attendanceModifiApp_list_title')"
    pad="0"
    @activated="activated"
  >
    <template v-slot:page-main>
      <Taber
        contentBackground="transparent"
        :curTab="curTab"
        special
        @change="(tab) => (curTab = tab)"
        :items="taber"
        @filter="
          (val, tab) => {
            if (tab == 1) {
              filterPageData1 = val;
            } else filterPageData2 = val;
          }
        "
      >
        <!-- 筛选 -->
        <template v-slot:filter-content-1="{ filter }">
          <div v-show="curTab === 'tab-1'">
            <Selections2
              :objects="filterObjects"
              small-chip
              @filter="
                filter();
                toFilter(1, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects, null, null);
                  if (apply) {
                    filter();
                    toFilter(1, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-2="{ filter }">
          <div v-show="curTab === 'tab-2'">
            <!-- 筛选 -->
            <Selections2
              :objects="filterObjects2"
              small-chip
              @filter="
                filter();
                toFilter(2, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects2, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects2, null, null);
                  if (apply) {
                    filter();
                    toFilter(2, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :filter-page-data="filterPageData1"
            :items="desserts"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback, data) => {
                getList(1, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0 ma-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="item.is_temp"
                      :src="item.staff_avatar"
                      :staff_name="item.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $getCommonLangValue(item.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $getCommonLangValue(item.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.record="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.attendance_utc_date, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                small
                @click="toView(item.uuid)"
                v-if="hasBtn('view-admin-attendance-modification-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :filter-page-data="filterPageData2"
            :headers="headers"
            :items="desserts2"
            :showSelect="showSelect"
            :height="$vuetify.breakpoint.height - 335"
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback, data) => {
                getList(2, data, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.applicant="{ item }">
              <div style="max-width: 300px">
                <v-list-item dense two-line class="pa-0 ma-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      :isTemp="item.is_temp"
                      size="36"
                      :src="item.staff_avatar"
                      :staff_name="item.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $getCommonLangValue(item.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ item.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $getCommonLangValue(item.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </template>
            <template v-slot:item.record="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.attendance_utc_date, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                small
                @click="toView(item.uuid)"
                v-if="hasBtn('view-admin-attendance-modification-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "AttendanceRecordModiApp",
  computed: {
    ...mapGetters(["SelectionRefresh"]),
  },
  watch: {
    SelectionRefresh(v) {
      if (v === 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
      }
    },
  },
  data() {
    return {
      curTab: "tab-1",
      totalCount1: 0,
      filterPageData1: null,
      filterPageData2: null,
      totalCount2: 0,
      showSelect: false,
      curuuid: null,
      taber: [
        "label_essweb_attendanceModifiApp_list_tab_underReviewLabel",
        "label_essweb_attendanceModifiApp_list_tab_completeLabel",
      ],
      headers: [
        {
          text: "label_essweb_attendanceModifiApp_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceModifiApp_list_attendanceRecordLabel",
          value: "record",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceModifiApp_list_submitDateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceModifiApp_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      showDelete: false,
      desserts2: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          avatar: true,
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_leaveApplication_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },

        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      filterObjects2: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          avatar: true,
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          statusChip: "approval",
          name: "status",
          multiple: true,
          label: "label_essweb_leaveApplication_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      first: false,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, null, 1, this.$tableSetting.perPageSize, null);
    this.getList(2, null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        // if (this.page !== null) {
        this.desserts1 = [];
        this.desserts2 = [];
        this.curTab = "tab-1";
        this.getList(1, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.getList(2, null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        this.first = true;
      }
      if (refresh == 1) {
        this.curTab = "tab-1";
        if (this.filterPageData1 || this.filterPageData2) {
          let page1 = 1,
            page2 = 1,
            pagesize1 = null,
            pagesize2 = null;
          if (this.filterPageData1 && this.filterPageData1["data"]) {
            page1 = this.filterPageData1["data"]["cpage"]
              ? this.filterPageData1["data"]["cpage"]
              : 1;
            pagesize1 = this.filterPageData1["data"]["pagesize"]
              ? this.filterPageData1["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData2 && this.filterPageData2["data"]) {
            page2 = this.filterPageData2["data"]["cpage"]
              ? this.filterPageData2["data"]["cpage"]
              : 1;
            pagesize2 = this.filterPageData2["data"]["pagesize"]
              ? this.filterPageData2["data"]["pagesize"]
              : null;
          }
          this.toFilter(1, () => {}, page1, pagesize1);
          this.toFilter(2, () => {}, page2, pagesize2);
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback, page, pagesize) {
      const that = this;
      let object = [];
      if (tab === 1)
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      if (tab === 2)
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );

      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "swift_number") {
          data["swift_number"] = item.value;
        }
      });
      if (!page) {
        this.getList(tab, data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          tab,
          data,
          page ? page : 1,
          pagesize ? pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (status, data, page, perpage, callback) {
      const that = this;
      if (page !== 1) this.page = page;
      else this.page = null;
      if (perpage !== this.$tableSetting.perPageSize) this.pagesize = perpage;
      else this.pagesize = null;
      this.selected = [];
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_application",
        url: "/attendance-modification-application/get-list/",
        data: data
          ? data
          : {
              approval_status: status,
              cpage: page,
              pagesize: perpage,
            },
      }).then((res) => {
        if (status == 1) {
          that.desserts = res.data;
          that.totalCount1 = res.totalcount;
          callback ? callback(page, perpage, data, status) : null;
        }
        if (status == 2) {
          that.desserts2 = res.data;
          that.totalCount2 = res.totalcount;
          callback ? callback(page, perpage, data, status) : null;
        }
      });
    },
    toView: function (uuid) {
      this.$toPage(
        "/admin/attendance-modification/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
            })
          )
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_application",
        url: "/attendance-modification-application/get-list/",
        data: { uuids: uuid },
      }).then((res) => {
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
  },
};
</script>
